export default __webpack_public_path__ + "static/pic01-b5237c7a6ee1be59e3104df91131dcad.jpg";